import React, { useState, useEffect, useRef } from 'react'
import MediaView from '../../components/views/MediaView';
import OpenedSidebar from "../../components/openedSidebar"
import { connect, useSelector} from 'react-redux';
import { dashboardActions } from '../../redux-utils/actions/dashboard-actions';
import { useAuth } from '../../custom-hooks/useAuth';
import Loader from '../../components/Loader';
import ClosedSidebar from '../../components/closedSidebar';





const { allParticipantAction } = dashboardActions;

function MediaData({allParticipantDispatchAction, allParticipantResult}) {
  const data = allParticipantResult?.allParticipantData || [];
  const isOpened = useSelector((state) => state.sidebarState.isOpen);
  
  if(allParticipantResult.allParticipantData && allParticipantResult.allParticipantData.length > 0) {
    return(
      <MediaView data={data} />
    )
  }

  return (
    (allParticipantResult.status === "" || allParticipantResult.status === "all_participant_fetch_start") ? (
      <div className="bg-[#F9F9F9] font-sans flex">
        {isOpened ? <OpenedSidebar/> : <ClosedSidebar/>}
        <Loader />
      </div>
    ) :
    (
      <MediaView data={data} />
    )
  )
}

const areEqual = (prevProps, nextProps) => {
  return prevProps.allParticipantResult.allParticipantData === nextProps.allParticipantResult.allParticipantData
};
const MediaMemo = React.memo(MediaData, areEqual)

function Media(props) {
  const { 
    allParticipantDispatchAction,
    allParticipantResult
  } = props;

  const { getLogin } = useAuth();
  const loginStorage = JSON.parse(getLogin());

  useEffect(() => {
    const allParam = {
      token: loginStorage && loginStorage.loginData.data.token
    }

    allParticipantDispatchAction(allParam);

  }, [])

  return (
    <>
      <MediaMemo 
        allParticipantDispatchAction={allParticipantDispatchAction} 
        allParticipantResult={allParticipantResult}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  allParticipantResult: state.dashboardState
});

const mapDispatchToProps = dispatch => ({
  allParticipantDispatchAction: (param) => dispatch(allParticipantAction(param)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Media);